import React from "react";
import styled from "styled-components";
import { desktop } from "../../BreakPoints";
import { Footer } from "./elements/Footer";
import { LinkButton } from "../../button/LinkButton";
import { useLocation } from "react-router-dom";


export const PublicLearningPageWrapper = ({ children }: React.PropsWithChildren<{}>) => {
    
    const location = useLocation();
    const isPublicRoot = location.pathname === "/learning/public";

    return (
        <Main>
            <PublicNavigation>
                <Wrapper>
                    <PublicLogo>
                        <img src="/images/amorg_logo_blue.svg" />
                    </PublicLogo>

                    {!isPublicRoot && (
                        <LinkButton
                            variant={"clean"}
                            href={"/learning/public"}
                            icon="navigation_home"
                            text="Oversigt"
                        /> 
                    )}
                </Wrapper>
            </PublicNavigation>
            <CoreContent className="mainContent">

                {children}

            </CoreContent>
            <CoreFooter>
                <Footer />
            </CoreFooter>
        </Main>
    );
};

const Main = styled.div`
    display:grid;
    min-height: 100%;
    grid-template-columns: auto;
    grid-template-rows: 100px auto min-content;
    grid-template-areas:
        "navigation"
        "content"
        "footer";

    @media (max-width: ${desktop}px) {
        grid-template-columns: auto;
        grid-template-rows: 65px auto min-content;
        grid-template-areas:
        "navigation"
        "content"
        "footer";
    }
`;

const CoreContent = styled.div`
    background: white;
    padding-bottom:20px;
    position: relative;
    z-index: 10;
    grid-area: content;
`;

const CoreFooter = styled.div`
    grid-area: footer;
`;

const PublicNavigation = styled.div`
    background: rgba(61, 61, 61, .1);
    align-self: start;
    height: 100px;
    width: 100%;
    margin:0 auto;
    box-shadow: 0px 8px 5px 0px rgba(0,0,0,0.25);
    -webkit-box-shadow: 0px 8px 5px 0px rgba(0,0,0,0.25);
    -moz-box-shadow: 0px 8px 5px 0px rgba(0,0,0,0.25);
    z-index:1000;
  
    @media (max-width: ${desktop}px) {
        height: 50px;
        width: 50px;
    }
`;


const Wrapper = styled.div<{wide?:boolean}>`
    width:100%;
    margin: auto;
    max-width: ${props => props.wide ? '90%' : '1020px'};
    padding:16px 0px;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    display: flex;
    flex-direction: row;
    padding: 0 10px;
`;


const PublicLogo = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    height: 50%;
    width: 50%;

    & img {
        height: 100%;
        width: auto;
        max-width: 100%;
    }
`;